import React, { useContext } from 'react';
import { Button, Progress } from 'antd';
import './styles.less';
import { ArrowLeftOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import steps from '../../../steps';
import { EnrollmentContext } from '../../../../../providers/EnrollmentContextProvider';

const EnrollmentProgressCircle = ({ onBack }) => {
  const { currentStepEnrollmentLegal, currentStepEnrollmentLegalIndex } = useContext(
    EnrollmentContext
  );
  const fixedCurrentStepIndex = Math.min(currentStepEnrollmentLegalIndex, steps.length - 2);
  const percent = Math.min(
    Math.ceil((100 * (fixedCurrentStepIndex + 1)) / (steps.length - 1 || 1)),
    99.999
  );

  return (
    <div className="enrollmentLegal-progress">
      {fixedCurrentStepIndex > 0 && currentStepEnrollmentLegalIndex < steps.length - 1 && (
        <Button type="link" className="enrollmentLegal-progress-back-button" onClick={onBack}>
          <ArrowLeftOutlined />
        </Button>
      )}
      <Progress
        className="enrollmentLegal-progress__indicator"
        type="circle"
        percent={percent}
        format={() => `${fixedCurrentStepIndex + 1} de ${steps.length - 1}`}
        width={57}
      />
      <div className="enrollmentLegal-progress__text">
        <h2 className="enrollmentLegal-progress__title">{currentStepEnrollmentLegal.title}</h2>
        <p className="enrollmentLegal-progress__description">
          {currentStepEnrollmentLegal.description}
        </p>
      </div>
    </div>
  );
};

EnrollmentProgressCircle.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default EnrollmentProgressCircle;
